export type TypographyTypes =
    | 'span'
    | 'p'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'a'
    | 'b'
    | 'del';
export type FontSizes =
    | 'link'
    | 'x-small'
    | 'small'
    | 'medium'
    | 'large'
    | 'x-large'
    | 'display1'
    | 'display2'
    | 'display3'
    | 'display4';

export type FontWeights =
    | '100'
    | '200'
    | '300'
    | '400'
    | '500'
    | '600'
    | '700'
    | '800'
    | '900';

export type OverflowTypes =
    | 'visible'
    | 'hidden'
    | 'clip'
    | 'scroll'
    | 'auto'
    | 'hidden visible'
    | 'inherit'
    | 'initial'
    | 'revert'
    | 'revert-layer'
    | 'unset';

export type TextOverflowTypes =
    | 'clip'
    | 'ellipsis ellipsis'
    | 'ellipsis'
    | 'inherit'
    | 'initial'
    | 'revert'
    | 'revert-layer'
    | 'unset';

export type TextAlignTypes =
    | 'right'
    | 'center'
    | 'left'
    | 'justify'
    | 'stretch';

export const TypographyAlignmentsDefault = TextAlign.right;

export type WhiteSpaceTypes =
    | 'normal'
    | 'nowrap'
    | 'pre'
    | 'pre-wrap'
    | 'pre-line'
    | 'break-spaces'
    | 'collapse balance'
    | 'preserve nowrap'
    | 'inherit'
    | 'initial'
    | 'revert'
    | 'revert-layer'
    | 'unset';
